// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__MbTxY","header_logo":"Header_header_logo__2Xarw","header__wrapper":"Header_header__wrapper__1C3Y5"};